import { render, staticRenderFns } from "./TileIframe.vue?vue&type=template&id=20b62a6b&scoped=true&"
import script from "./TileIframe.vue?vue&type=script&lang=ts&"
export * from "./TileIframe.vue?vue&type=script&lang=ts&"
import style0 from "./TileIframe.vue?vue&type=style&index=0&id=20b62a6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b62a6b",
  null
  
)

export default component.exports